import React from "react";
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import logo from "../../Assets/logo.png";
import { Meteors } from "../Components/Meteors";

const Navbar = () => {
  return (
    <nav className="navbar relative w-full z-10">
      <div className="relative shadow-xl bg-gray-900 border border-gray-800 px-6 py-8 mx--2 overflow-hidden rounded-b-1xl w-full">
        <div className="flex flex-row items-center justify-between relative z-10 px-6">
          <Link to="/">
            <motion.img 
              src={logo} 
              alt="Logo" 
              className="h-20 filter brightness-150"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
            />
          </Link>
          <div className="flex justify-end w-full max-w-3xl flex-wrap">
            {["About", "Contact", "Start Application"].map((text) => (
              <Link
                key={text}
                to={text === "Start Application" ? "/start-application" : `/${text.toLowerCase()}`}
                className="text-white mx-2 no-underline transition-colors duration-300 cursor-pointer p-2 text-base font-['Plus Jakarta Sans', sans-serif] hover:text-yellow-400"
              >
                {text}
              </Link>
            ))}
          </div>
        </div>
        
        {/* Meteor effect */}
        <Meteors number={20} className="absolute inset-0" />
      </div>
    </nav>
  );
};

export default Navbar;
